import Utils from "./Utils";

import { FormSectionElements, FormSections, FormSubSections, LOVValues, ProgramContainer } from "../entities/formTemplateDataType";
import { filterableElements, inputElements } from "../entities/Constants";
import XMLParser from "../utilities/XMLParser";

export const getSectionFilterValueMap = (section: FormSections): Record<string, string[]> => {
    if (!section) return {};

    const filterValue = section.FilterValue as any;

    if (filterValue && !Array.isArray(filterValue) && typeof filterValue === 'object') {
        return filterValue as Record<string, string[]>;
    }

    const map: Record<string, string[]> = {};
    if (Array.isArray(filterValue) && Array.isArray(section.FilterField)) {
        section.FilterField.forEach((fieldName: string, index: number) => {
            const valueAtIndex = filterValue[index];
            if (Array.isArray(valueAtIndex)) {
                map[fieldName] = valueAtIndex;
            } else if (valueAtIndex != null && valueAtIndex !== '') {
                map[fieldName] = [valueAtIndex];
            }
        });
    } else if (typeof filterValue === 'string' && filterValue) {
        const fieldKey = Array.isArray(section.FilterField) ? section.FilterField[0] : section.FilterField;
        if (fieldKey) {
            map[fieldKey] = [filterValue];
        }
    }

    section.FilterValue = map;
    return map;
};


export const getParentSection = (element: FormSectionElements | FormSubSections ): FormSections | undefined => {
    if (element) {
        let section = element.parent;
        while(section && !section.ListOfFormSubSections) {
            section = section.parent; 
        }
        if (section) {
            return section;
        }
    }
    return undefined;
}

export const getParentSubSection = (element: FormSectionElements): FormSubSections | undefined => {
    if (element) {
        let section = element.parent;
        while(section && !section.ListOfFormSectionElements) {
            section = section.parent; 
        }
        if (section) {
            return section;
        }
    }
    return undefined;
}

export const getRootComponent = (field: FormSectionElements | FormSubSections | FormSections): ProgramContainer => {
    let section = field.parent;
    while(section && !section.ListOfFormSections) {
        section = section.parent;
    }
    return section;
}

export const isBxpForm = (field: FormSectionElements | FormSubSections | FormSections | string): boolean => {
    if (typeof field === 'string') {
        return field.toUpperCase().startsWith('BXP-');
    }
    const root =  getRootComponent(field);
    return root?.CategoryId?.toUpperCase().startsWith('BXP-');
} 


export const isFirstElement = (element: FormSectionElements): boolean => {
    if (element) {
        const index = element.parent.ListOfFormSectionElements.findIndex(ele => ele.Id === element.Id);
        return index === 0;
    }
    return false;
};

export const isLastElement = (element: FormSectionElements): boolean => {
    if (element) {
        const elements = element.parent.ListOfFormSectionElements;
        const index = elements.findIndex(ele => ele.Id === element.Id);
        return index === (elements.length -1);
    }
    return false;
};

export const getElementByFieldName = (fieldName: string, formSection: FormSections): FormSectionElements => {
    const root = formSection.parent;

    const formList = root.ListOfFormSections;
    let eleReturned;
    try {
        formList.forEach(section => {
            section.ListOfFormSubSections.forEach(sub => {
                const elements = sub.ListOfFormSectionElements;
                elements.forEach(ele => {
                    if (ele.LoadBindName == fieldName) {
                        eleReturned = ele;
                        throw new Error('Exit all loops');
                    }
                })
            })
        });
    } catch {
        return eleReturned;
    }

    return null;
};
  
export const findSectionElementByFieldName = (formSectionElements: FormSectionElements[], name: string): FormSectionElements => {
    return formSectionElements.find(element => element.LoadBindName === name);
}

export const findDependency = (programContainer: ProgramContainer, fieldName: string) => {
    if(Utils.isNullOrEmpty(fieldName)) return null;
    let ret=''
    programContainer.ListOfFormSections.forEach((formSection) => {
        if(formSection.FilterField&&formSection.FilterField.length>0){
            const sectionFilters = getSectionFilterValueMap(formSection);
            formSection.FilterField.forEach((fld)=>{
                const values = sectionFilters[fld] || [];
                if(fld===fieldName&&values.length>0){
                    ret=ret + `${formSection.ENUTitle}>Sequence ${formSection.Sequence}` +'\n\n';
                }
            }) 
        }
        formSection.ListOfFormSubSections.forEach(subSec => {
            if(subSec.FilterField&&subSec.FilterField.length>0){
                subSec.FilterField.forEach((fld,index:number)=>{
                    if(fld===fieldName&&subSec.FilterValue[index]&&subSec.FilterValue[index].length>0){
                        ret=ret + `${formSection.ENUTitle}(Sequence ${formSection.Sequence})>${subSec.ENUTitle}(subSection:Sequence ${subSec.Sequence})` +'\n\n';
                    }
                } )
            }
            subSec.ListOfFormSectionElements.forEach(element => {
                if(element.FilterField&&element.FilterField===fieldName){
                    ret=ret + `${formSection.ENUTitle}(Sequence ${formSection.Sequence})>${subSec.ENUTitle}(subSection:Sequence ${subSec.Sequence})>${element.ENUTitle}(element:Sequece${element.Sequence})` +'\n';
                }
                if(element.Datatype==='Row'){
                if (element.subSectionList != null && element.subSectionList.length > 0) {
                    element.subSectionList[0].ListOfFormSectionElements.map((ele) => {
                        if(ele.FilterField&&ele.FilterField===fieldName){
                            ret=ret + `${formSection.ENUTitle}(Sequence ${formSection.Sequence})>${subSec.ENUTitle}(subSection:Sequence ${subSec.Sequence})>Row element: ${ele.ENUTitle}(Sequece${ele.Sequence})` +'\n\n';
                        }
                    })
                    }
                }
            })
        })
    })
    return ret;
}


export const getSectionElementByFieldName = (fieldName: string, formSubSections: FormSubSections): FormSectionElements => {
    const root = formSubSections.parent;

    const formList = root.ListOfFormSubSections;
    let eleReturned;
    try {
        formList.forEach(sub => {
            const elements = sub.ListOfFormSectionElements;
            elements.forEach(ele => {
                if (ele.LoadBindName == fieldName) {
                    eleReturned = ele;
                    throw new Error('Exit all loops');
                }
            })
        })

    } catch {
        return eleReturned;
    }

    return null;
};

export const getNearstParent = (element: HTMLElement, parentName: string) => {
    if (!parentName) return null;
    let parent = element.parentElement;
    while (parent && parent.nodeName.toLocaleLowerCase() !== parentName.toLocaleLowerCase()) {
        parent = parent.parentElement;
    }
    return parent;
};

export const scrollToContentHeader = (element: HTMLElement) => {
    const h1 = getNearstParent(element, 'h1');
    if (h1) {
        h1.focus();
    }
};

export const focusOnSectionHeader = (section: FormSections) => {
    let invalidElement = null;
    let invalidSubsec = null
    let index = 0;
    let h1Ids: string[] = [];

    for (let subSection of section.ListOfFormSubSections) {
        h1Ids = [];
        for (let i=0; i< subSection.ListOfFormSectionElements.length; i++) {
            const element = subSection.ListOfFormSectionElements[i];
            if (!element.Visible) {
                continue;
            }

            if (element.Datatype === 'Label' || element.Datatype === 'HTML') {
                h1Ids.push(section.Id + '-' + subSection.Sequence + '-' + element.Id);
            }
            if (!element.Valid && element.Visible) {
                invalidElement = element;
                invalidSubsec = subSection;
                index = i;
                break;
            }
        }
    }
    
    if (invalidElement && h1Ids.length) {
        const h1Elements = Array.from(h1Ids).map(h1Id => document.querySelector(`div#Label-${h1Id} h1`))
            .filter(Boolean);
        if (h1Elements.length) {
            const h1 = h1Elements.pop() as HTMLHeadingElement;
            h1.focus();
        }
    }
}

export const findMatchedAddressElement = (field: FormSectionElements): FormSectionElements | null => {
    const subSection = field.parent;
    for(let element of subSection.ListOfFormSectionElements) {
        const type = field.addressType === 'Mailing' ? 'Residential' : 'Mailing';
        if (element.Datatype === 'Address' && element.addressType === type) {
            return element;
        }
    }
    return null;
}

export const focusOnFirstErrorElement = () => {
    const errorEle = getFirstErrorElement();
    if (errorEle) {
        (errorEle as HTMLInputElement ).focus();
    };
}

export const getFirstErrorElement = () => {
    const pattern = /ontario-[a-z]+__error/i;
    const elements = document.querySelectorAll('[class*="__error"]');
    return Array.from(elements).filter(ele => pattern.test(ele.className))?.[0];
}


export const getAppId = (field: FormSectionElements | FormSubSections | FormSections): string => {
    const root = getRootComponent(field);
    return root?.CategoryId ?? '';
}

export const isSectionVisible = (section: FormSections, programContainer: ProgramContainer, callback: (p: ProgramContainer) => void): boolean => {
    section.ListOfFormSubSections.forEach(sub => {
        sub.ListOfFormSectionElements.forEach(ele => {
            if (ele.Datatype === 'PublicSecureButton') {
                if (programContainer.Profile?.userId) {
                    if (section.Visible) {
                        section.Visible = false;
                        callback(programContainer);
                    }
                } else {
                    if (!section.Visible) {
                        section.Visible = true;
                        callback(programContainer);
                    }
                }
            }
        });
    });
    return section.Visible;
}

export const setPublicSecurePageVisibility = (field: FormSectionElements, callback: (p: ProgramContainer) => void): void => {
    if (field.Datatype !== 'PublicSecureButton') return;

    const root = getRootComponent(field);
    const url = new URL(window.location.href)
    const code = url.searchParams.get("code");
    const state = url.searchParams.get('state'); 
    
    const section = field.parent.parent;
    if (root.Profile?.userId) {
        if (section.Visible) {
            section.Visible = false;
            callback(root);
        }
    } else if (code && state) {
        if (section.Visible) {
            section.Visible = false;
            callback(root);
        }   
    } else {
        if (!section.Visible) {
            section.Visible = true;
            callback(root);
        }
    }
}

export const hasPublicSecureButton = (section: FormSections): boolean => {
    let hasButton = false;
    section.ListOfFormSubSections.forEach(sub => {
        sub.ListOfFormSectionElements.forEach(ele => {
            if (ele.Datatype === 'PublicSecureButton') {
                hasButton = true;
            }
        });
    });
    return hasButton;
}

export const getPublicSecurePage = (sections: FormSections[]): FormSections => {
    return sections.find(section => hasPublicSecureButton(section));
};

export const needAccessToken = (section: FormSections): boolean => {
    let needToken = section.GetToken === 'Y';
    const hasPublicSecureBtn = hasPublicSecureButton(section);
    if (hasPublicSecureBtn) {
        const root = getRootComponent(section);
        if (!root.Profile?.token) {
            needToken = true;
        }
    }
    return needToken;
}

export const needCxpProfile = (section: FormSections): boolean => {
    let needProfile = false;
    const hasPublicSecureBtn = hasPublicSecureButton(section);
    if (hasPublicSecureBtn) {
        const root = getRootComponent(section);
        if (!root.Profile?.lastName || !root.Profile?.firstName) {
            needProfile = true;
        }
    }
    return needProfile;
}

export const getSubSectionButton = (subSection: FormSubSections): FormSectionElements | null => {
    if (!subSection) return null;
    const buttons = subSection.ListOfFormSectionElements.filter(ele => ele.Datatype === 'Button' && ele.Visible);
    return buttons[0] ?? null;
};

export const getFieldByName = (name: string, field: FormSectionElements | FormSections): FormSectionElements | undefined => {
    const root = getRootComponent(field);
    let bindField;
    root.ListOfFormSections.forEach(section => {
        section.ListOfFormSubSections.forEach(sub => {
            sub.ListOfFormSectionElements.forEach(ele => {
                if (ele.LoadBindName === name) {
                    bindField = ele;
                }
            });
        });
    });
    return bindField;
}

export const findAddressElement = (summaryField: FormSectionElements) => {
    const root = getRootComponent(summaryField);
    let addressField: FormSectionElements;
    let find = false;
    
    for (const form of root.ListOfFormSections) {
        if (find) break;
        for (const subForm of form.ListOfFormSubSections) {
            const fields = subForm.ListOfFormSectionElements.filter(ele => (
                ele.Datatype==='Address' && (ele.addressType ?? 'Residential') === (summaryField.addressType ?? 'Residential')
            ));

            if (fields.length) {
                addressField = fields[0];
                find = true;
                break;
            }
        }
    }
    return addressField;
}

export const generateSectionIndex = (element: FormSectionElements) => {
    const root = getRootComponent(element);
    const index = root.ListOfFormSections.map(section => {
        return {sequence: section.Sequence, title: section.ENUTitle };
    });
    return index;
};

export const getSectionBySequence = (field: FormSectionElements, sequence: number = undefined) => {
    const root = getRootComponent(field);
    if (sequence) {
        return root.ListOfFormSections.find(section => section.Sequence === sequence);
    }
    return field.parent.parent;
};

export const isEventWithinElement = (event: MouseEvent, element: HTMLElement): boolean => {
    const rect = element.getBoundingClientRect();
    return (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
    );
};

export const isInputElement = (element: FormSectionElements) => {
    return inputElements.includes(element.Datatype);
}


export const getOtherFieldOptions = (field: FormSectionElements, lang='en') => {
    const root = getRootComponent(field);
    const section = field.parent.parent.Datatype==='Row'? field.parent.parent.parent.parent: field.parent.parent as FormSections;
    const elementListWithOptions = [{code: null, description: 'Select'}];
    const elements = [];
    let elementList=[]
    if(field.parent.parent.Datatype==='Row'){
        const section = field.parent.parent.parent.parent as FormSections;
        const currentSubSeq = field.parent.parent.parent.Sequence;
        section.ListOfFormSubSections.filter(sub=>sub.Sequence<=currentSubSeq).forEach(sub=>{
            sub.ListOfFormSectionElements.forEach(ele=>{
                if(ele.Datatype==='Row'&&ele.subSectionList){
                    ele.subSectionList[0].ListOfFormSectionElements.forEach(el=>{
                        if(sub.Sequence<field.parent.parent.parent.Sequence || ele.Sequence<field.parent.parent.Sequence || ele.Sequence==field.parent.parent.Sequence&&el.Sequence<field.Sequence ){
                            elementList.push(el)
                        }
                    })
                }else{
                    if(sub.Sequence<field.parent.parent.parent.Sequence || ele.Sequence<field.parent.parent.Sequence){
                        elementList.push(ele)
                    }
                }
            })
        })
    }else{
        const section = field.parent.parent as FormSections;
        let currentSubSeq = field.parent.parent.Sequence;
        section.ListOfFormSubSections.filter(sub=>sub.Sequence<=currentSubSeq).forEach(sub=>{
            sub.ListOfFormSectionElements.forEach(ele=>{
                if(ele.Sequence<field.Sequence){
                    if(ele.Datatype==='Row'&&ele.subSectionList){
                        ele.subSectionList[0].ListOfFormSectionElements.forEach(el=>{
                            elementList.push(el)
                        })
                    }
                    elementList.push(ele)
                }
            })
        })
    }

    elements.push(...elementList);


    let list = elements.filter(q => (filterableElements.includes(q.Datatype)))
        .map((q) => ({
            code: q.LoadBindName?.replace(/\s/g, ""),
            description: lang === 'en' ? q.ENUTitle : q.FRATitle
        }));
    elementListWithOptions.push(...list);
    return elementListWithOptions;
}

export const getFilterFieldValues = (field: FormSectionElements): {[key: string]: LOVValues[]}[] => {
    if (!field || !filterableElements.includes(field?.Datatype)) {
        return [];
    }
    
    const container = {};
    const emptyOption = {code: null, description: 'Select'} as LOVValues;
    if (field.Datatype == "Checkbox") {
        const yLOVValue = new LOVValues();
        yLOVValue.code = "Y";
        yLOVValue.description = "Y";
        const nLOVValue = new LOVValues();
        nLOVValue.code = "N";
        nLOVValue.description = "N";
        container[field.LoadBindName] = [emptyOption, yLOVValue, nLOVValue];
    } else {
        container[field.LoadBindName] = [emptyOption, ...field.ListOfLOVValues ?? []];
    }
    return [container];
}

export const displayField = (field: FormSectionElements) => {
    if (!field.FilterField || !field.FilterValue) return field.Visible ?? true;

    // let baseName;
    // let bindName;
    // let parts = field.FilterField.split('.');
    // if (parts.length == 3) {
    //     baseName = parts[0] + '.' + parts[1];
    //     bindName = parts[2];
    // }
    // if (parts.length == 2) {
    //     baseName = parts[0];
    //     bindName = parts[1];
    // }
    // if (parts.length == 1) {
    //     baseName = '';
    //     bindName = parts[0];
    // }

    const fullPath = field.FilterField;
    const parts = fullPath.split('.');
    const bindName = parts[parts.length - 1];
    
    // console.log("field:", field);
    // console.log("field:", field);
    // console.log("bindName:", bindName);
    
    // Search with bindName
    let foundFilterField = XMLParser.findSectionElement?.(field, bindName);
    
    // If bindName fails, use fullPath (user may enter names with dot notation)
    if (!foundFilterField) {
        // console.log("Searching with fullPath:", fullPath);
        foundFilterField = XMLParser.findSectionElement(field, fullPath);
    }

    // console.log("foundFilterField:", foundFilterField);
    // console.log("foundFilterField:", foundFilterField);
    
    let filterValue;
    if (foundFilterField != null) {
        filterValue = foundFilterField.Value;
    }
    // console.log("actual filterValue:", filterValue);
    
    if (foundFilterField && !foundFilterField.Visible) return false;
    // const display = !(foundFilterField != null && (filterValue == null || filterValue == '')) || filterValue != null && (field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(field.FilterValue) == -1)
    let disp = foundFilterField && filterValue && typeof filterValue === 'string' && (field.FilterValue?.indexOf(filterValue) >=0 || filterValue?.indexOf(field.FilterValue) >= 0);
    if ((foundFilterField?.Datatype == "Checkbox")) {
        disp = (!filterValue && field.FilterValue == "N") || (filterValue == field.FilterValue);
    }

    if (field.FilterCompareMethod != null && field.FilterCompareMethod != '' && foundFilterField != null && foundFilterField.Datatype == 'Date') {
        if (foundFilterField.Value) {
            let otherDate = new Date(foundFilterField.Value);
            let today = new Date();
            var diff = otherDate.getTime() - today.getTime();
            var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            if (field.FilterCompareMethod == 'greater')
                disp = diffDays <= Number.parseInt(field.FilterValue);
            else
                disp = diffDays >= Number.parseInt(field.FilterValue);
        } else {
            disp = false;
        }
    }
    return disp;
}

/*
export const populateElementFindRoot = (programContainer:ProgramContainer) => {
    if (programContainer == null) return;
    programContainer.ListOfFormSections.forEach((formSection) => {
        formSection.ListOfFormSubSections.forEach(subSec => {
            subSec.ListOfFormSectionElements.forEach(element => {
                element.findRoot=()=>{
                    return programContainer;
                }
                if(element.Datatype==='Row'){
                if (element.subSectionList != null && element.subSectionList.length > 0) {
                    element.subSectionList[0].ListOfFormSectionElements.map((ele) => {
                        ele.findRoot=()=>{
                        return programContainer;
                        }
                    })
                    }
                }
            })
        })
    })
}
*/
export const getSequencedSteps = (programContainer: ProgramContainer): FormSections[] => {
    return programContainer?.ListOfFormSections?.filter(p => p.Visible && !p.NotStep && !p.IsTechErrorPage && !p.IsInfoPage && !p.IsConfirmationPage && !p.IsTerminationPage);
}

export const getCurrentSectionStep = (section: FormSections) => {
    if (section.Visible && !section.NotStep && !section.IsTechErrorPage && !section.IsInfoPage && !section.IsConfirmationPage && !section.IsTerminationPage) return null;
    const steps = getSequencedSteps(section.parent);
    return steps.indexOf(section);
}

export const getCustomizedSummaryComponentStep = (programContainer: ProgramContainer) => {
    const steps = getSequencedSteps(programContainer);
    const summary = programContainer.ListOfFormSections.filter(
        sec => sec.CustomizedReviewPage && !sec.ExcludeFromCustomizedSummary
    );
    if (summary.length) {
        return  programContainer.ListOfFormSections.indexOf(summary[0]);
    }
    return null;
}

export const triggerSummaryListFilter = (field: FormSectionElements) => {
    const fieldAny = field as any;
    if (!fieldAny?.filterSummaryListId) return;

    const root = getRootComponent(field);
    const sections = root?.ListOfFormSections ?? [];

    const findAndTrigger = (elements: any[]): boolean => {
        for (const element of elements ?? []) {
            if (element.Id === fieldAny.filterSummaryListId && element._triggerFilter) {
                element._triggerFilter();
                return true;
            }
            if (element.subSectionList?.length) {
                for (const sub of element.subSectionList) {
                    if (findAndTrigger(sub?.ListOfFormSectionElements)) return true;
                }
            }
        }
        return false;
    };

    for (const section of sections) {
        for (const subSection of section.ListOfFormSubSections ?? []) {
            if (findAndTrigger(subSection.ListOfFormSectionElements)) return;
        }
    }
};

export const isSummaryLinked = (field: FormSectionElements): boolean => {
    const fieldAny = field as any;
    const hasColumns = 
        Array.isArray(fieldAny?.filterSummaryListColumns) && fieldAny.filterSummaryListColumns.length > 0 ||
        Boolean(fieldAny?.filterSummaryListColumn);
    return Boolean(fieldAny?.filterSummaryListId && hasColumns);
};

export const updateFilterSelectionCode = (
    field: FormSectionElements, 
    value: string | null
) => {
    const fieldAny = field as any;
    if (fieldAny.SearchFilter?.enabled || fieldAny.filterSummaryListId) {
        fieldAny.SelectionCode = value;
    }
};